export default "__VITE_ASSET__4e36f9c9__"